import React from "react";
import {Row, Col, BackTop} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner, ImageAuto } from "@reco-w/core-ui";
import { Namespaces, entrustModel } from "@reco-w/merchants-models";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination, Thumbs } from "swiper";
import { R2040ArticleList } from "src/apps/common/r2040.article.list";
import { Consulting } from "src/apps/consulting/consulting";
SwiperCore.use([Autoplay, Navigation, Pagination, Thumbs]);

export namespace Entrust {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> { }

    export interface IState extends ViewComponent.IState, entrustModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.entrust;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/entrust`);
        }
        componentDidMount() {
            this.dispatch("input", { newsSlides: 3, newsSpace: 0, caseSlides: 2, caseSpace: 40, customerSlides: 5 });
            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });
        }

        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 1200) {
                this.dispatch("input", { newsSlides: 1, newsSpace: 0, caseSlides: 1, caseSpace: 0, customerSlides: 2 });
            } else {
                this.dispatch("input", { newsSlides: 3, newsSpace: 60, caseSlides: 2, caseSpace: 40, customerSlides: 5 });
            }
        }

        renderReason() {
            const reasonData = [
                {
                    imgUrl: "assets/images/second/reason-img1.jpg",
                    name: "懂企业",
                    desc: "10万+企业的认可"
                },
                {
                    imgUrl: "assets/images/second/reason-img2.jpg",
                    name: "懂园区",
                    desc: "500+园区政府合作"
                },
                {
                    imgUrl: "assets/images/second/reason-img3.jpg",
                    name: "有工具",
                    desc: "数智化产业服务平台"
                },
                {
                    imgUrl: "assets/images/second/reason-img4.jpg",
                    name: "有案例",
                    desc: "1000+落地项目"
                }
            ]
            return (
                <div className="block-content reason-content">
                    <img className="reason-word" src="assets/images/second/reason-word.png" />
                    <div className="container">
                        <div className="second-title">
                            <span>选择我们的理由</span>
                        </div>
                        <Row className="reason-gird" gutter={{ xs: 12, sm: 12, md: 24 }}>
                            {
                                reasonData.map((item, i) => {
                                    return (
                                        <Col xs={12} sm={12} md={6} key={i}>
                                            <div className="reason-gird-item">
                                                <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" />
                                                <div className="reason-gird-write">
                                                    <div className="size-22 white-color">{item.name}</div>
                                                    <div className="size-14 white-color mt5">{item.desc}</div>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            )
        }

        renderQuestion() {
            return (
                <div className="block-content question-content">
                    <div className="container">
                        <div className="second-title">
                            <span>选择我们的理由</span>
                        </div>
                        <Row className="question-grid" gutter={30}>
                            <Col xs={24} sm={24} md={8}>
                                <div className="question-grid-item">
                                    <div className="question-grid-img">
                                        <ImageAuto.Component src="assets/images/second/question-img1.jpg" width='100%' height="100%" />
                                    </div>
                                    <div className="question-grid-write">
                                        <div className="question-grid-word"><img src="assets/images/second/letter1.png" /></div>
                                        <div className="size-22">地方经济指标</div>
                                        <div className="question-grid-line mt10">投资额、税收额</div>
                                        <div className="mt60"><img src='assets/images/home/white-arrow.png' /></div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                                <div className="question-grid-item">
                                    <div className="question-grid-img">
                                        <ImageAuto.Component src="assets/images/second/question-img2.jpg" width='100%' height="100%" />
                                    </div>
                                    <div className="question-grid-write">
                                        <div className="question-grid-word"><img src="assets/images/second/letter2.png" /></div>
                                        <div className="size-22">产业指标</div>
                                        <div className="question-grid-line mt10">
                                            入驻企业、大项目引进数<br />
                                            内资到位、重大产业项目数
                                        </div>
                                        <div className="mt60"><img src='assets/images/home/white-arrow.png' /></div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={8}>
                                <div className="question-grid-item">
                                    <div className="question-grid-img">
                                        <ImageAuto.Component src="assets/images/second/question-img3.jpg" width='100%' height="100%" />
                                    </div>
                                    <div className="question-grid-write">
                                        <div className="question-grid-word"><img src="assets/images/second/letter3.png" /></div>
                                        <div className="size-22">产业转型升级</div>
                                        <div className="question-grid-line mt10">
                                            引进新产业、新业态<br />
                                            盘活空置载体资源
                                        </div>
                                        <div className="mt60"><img src='assets/images/home/white-arrow.png' /></div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            )
        }


        renderCase() {
            return (
                <div className="block-content case-content type1">
                    <div className="container">
                        <div className="second-title">
                            <span>案例展示</span>
                        </div>
                        {this.renderEmbeddedView(R2040ArticleList.Page, {
                            caseType: 2, tagIds: ["887893341152133120"]
                        } as any)}

                    </div>
                </div>
            )
        }

        renderStep() {
            return (
                <div className="block-content step-content type1">
                    <div className="container">
                        <div className="second-title">
                            <span>先体验后付费</span>
                        </div>
                        <div className="step-box">
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon iconkpi" /></div>
                                <div className="step-box-name">确定KPI</div>
                                <div className="step-box-desc">签订合同，确定项目需求和落地数量</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon icondingxiang" /></div>
                                <div className="step-box-name">定向开发</div>
                                <div className="step-box-desc">根据需求与情况，形成画像聚焦目标企业开发</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon iconshenhe" /></div>
                                <div className="step-box-name">审核质检</div>
                                <div className="step-box-desc">项目经过考察审核达到标准确定为真实有效项目</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon iconduijie" /></div>
                                <div className="step-box-name">对接确认</div>
                                <div className="step-box-desc">2个精准对接，地方政府确认签字，项目有效</div>
                            </div>
                            <div className="step-box-item">
                                <div className="step-box-icon"><i className="icon iconfufei" /></div>
                                <div className="step-box-name">进度付费</div>
                                <div className="step-box-desc">按合同签订付款进度对接、落地数量，进行付费</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        renderStrategic() {
            const { state } = this.props,
                customerSlides = state!.customerSlides;
            const customerData = [
                { imgUrl: "assets/images/home/customer-logo1.png" },
                { imgUrl: "assets/images/home/customer-logo2.png" },
                { imgUrl: "assets/images/home/customer-logo3.png" },
                { imgUrl: "assets/images/home/customer-logo4.png" },
                { imgUrl: "assets/images/home/customer-logo5.png" },
                { imgUrl: "assets/images/home/customer-logo6.png" },
                { imgUrl: "assets/images/home/customer-logo7.png" },
                { imgUrl: "assets/images/home/customer-logo8.png" },
                { imgUrl: "assets/images/home/customer-logo9.png" },
                { imgUrl: "assets/images/home/customer-logo10.png" },
                { imgUrl: "assets/images/home/customer-logo11.png" },
                { imgUrl: "assets/images/home/customer-logo12.png" },
                { imgUrl: "assets/images/home/customer-logo13.png" },
                { imgUrl: "assets/images/home/customer-logo14.png" },
                { imgUrl: "assets/images/home/customer-logo15.png" },
                { imgUrl: "assets/images/home/customer-logo16.png" },
                { imgUrl: "assets/images/home/customer-logo17.png" },
                { imgUrl: "assets/images/home/customer-logo18.png" },
                { imgUrl: "assets/images/home/customer-logo19.png" },
                { imgUrl: "assets/images/home/customer-logo20.png" }
            ]
            return (
                <div className="block-content pb20">
                    <div className="container">
                        <div className="second-title">
                            <span>合作伙伴</span>
                        </div>
                        <Swiper
                            slidesPerView={customerSlides}
                            slidesPerColumn={2}
                            className="customer-swiper"
                            style={{ height: 350 }}
                            pagination={true}
                            spaceBetween={30}
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                            }}
                        >
                            {customerData.map((item, i) => {
                                return (
                                    <SwiperSlide key={i}>
                                        <div className="customer-img">
                                            <img src={item.imgUrl} />
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </div>
            )
        }


        renderNews() {
            return (
                <div className="block-content" style={{ backgroundColor: "#f8f8f8" }}>
                    <div className="container">
                        <div className="second-title">
                            <span>招商动态</span>
                        </div>
                        {this.renderEmbeddedView(R2040ArticleList.Page, {
                            tagIds: ["887893341181493248"]
                        } as any)}
                        {/* <div className="news-swiper-box">
                            <Swiper
                                slidesPerView={newsSlides}
                                className="news-swiper mt10"
                                style={{ height: 460 }}
                                pagination={true}
                                spaceBetween={newsSpace}
                            >
                                {newsData.map((item, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="news-swiper-item">
                                                <div className="news-img">
                                                    <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                </div>
                                                <div className="pg20">
                                                    <Paragraph ellipsis={{ rows: 2, expandable: false }} className="mb0 size-18 gray-one-color">
                                                        {item.title}
                                                    </Paragraph>
                                                    <Paragraph ellipsis className="mb0 size-14 gray-three-color mt12">
                                                        {item.desc}
                                                    </Paragraph>
                                                    <div className="mt20">
                                                        <span className="list-arrow" />
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div> */}
                    </div>
                </div>
            )
        }

        renderConsult() {
            return <Consulting.Page renderType={1} orderCode="guanwcyzs"></Consulting.Page>
            // return (
            //     <div className="block-content consult-content">
            //         <div className="container">
            //             <div className="second-title line-no white-color">
            //                 <span>立即咨询定制方案</span>
            //             </div>
            //             <div className="consult-form">
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的姓名" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的单位" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的联系方式" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Button type="primary" ghost block shape="round">立即咨询</Button>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/banner/wt-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1"><img src="assets/images/banner/wt-text.png" /></div>
                                <div className="banner-text-name2 mt25">
                                    <div>瞄准·研判·服务·转化</div>
                                    <div className="mt10">四步精准招商</div>
                                </div>
                            </div>}
                        />
                        {this.renderReason()}
                        {this.renderQuestion()}
                        {this.renderCase()}
                        {this.renderStep()}
                        {this.renderStrategic()}
                        {this.renderNews()}
                        {this.renderConsult()}

                        <div className="scoll-top">
                            <BackTop visibilityHeight={50} />
                        </div>
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.entrust]);
}
